import React, { useState, useEffect } from 'react';
import ContentPage from '../components/ContentPage';
import { publicApi } from '../lib/api';

export default function ZonePage() {
  const [sectors, setSectors] = useState([]);

  useEffect(() => {
    publicApi.getPublicSectors().then((res) => setSectors(res.data || [])).catch(() => setSectors([]));
  }, []);

  const bookable = sectors.filter((s) => s.bookable !== false);

  return (
    <ContentPage
      pageId="zone-intervention"
      relatedLinks={[
        { to: '/comment-ca-marche', label: 'Découvrir comment fonctionne Mitonner' },
        { to: '/tarifs', label: 'Voir les tarifs' },
        { to: '/contact', label: 'Contacter Mitonner' },
      ]}
    >
      <div data-testid="zone-dynamic" className="mb-6">
        {bookable.length > 0 ? (
          <div className="space-y-4">
            {bookable.map((s) => (
              <div key={s.sector_id} className="bg-white rounded-2xl border border-[#E3DED5] p-6" data-testid={`zone-sector-${s.sector_id}`}>
                <div className="flex items-center justify-between flex-wrap gap-2">
                  <h2 className="font-['Cormorant_Garamond'] text-xl font-semibold text-[#2A312C]">{s.name}</h2>
                  {Number(s.travel_surcharge || 0) > 0 ? (
                    <span className="px-2 py-0.5 rounded-full text-xs bg-[#C86B51]/10 text-[#C86B51]">Supplément déplacement : {Number(s.travel_surcharge).toFixed(0)} €</span>
                  ) : (
                    <span className="px-2 py-0.5 rounded-full text-xs bg-[#A5BBA8]/20 text-[#2A312C]">Sans supplément</span>
                  )}
                </div>
                {(s.postal_codes || []).length > 0 && (
                  <p className="text-sm text-[#5C6A61] mt-2">Codes postaux : {s.postal_codes.join(', ')}</p>
                )}
                {(s.cities || []).length > 0 && (
                  <p className="text-sm text-[#5C6A61] mt-1">Communes : {s.cities.join(', ')}</p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-[#E3DED5] p-6 text-[#5C6A61]" data-testid="zone-empty">
            Nos zones d’intervention sont en cours de mise à jour. La disponibilité exacte est confirmée lors de la réservation, selon votre code postal.
          </div>
        )}
        <p className="text-xs text-[#5C6A61] mt-4">
          La disponibilité dépend de votre secteur et de votre code postal. Certaines zones plus éloignées peuvent être desservies selon les conditions affichées lors de la réservation.
        </p>
      </div>
    </ContentPage>
  );
}
